import TextField from '@mui/material/TextField';
import {
  Box, CircularProgress,
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { Linkedin } from '../../../../icons/linkedin';
import { BrokenImage } from '../../../../icons/broken-image';
import STRING_KEYS from '../../../../language/keys';
import AccountLinkedinDialogError from '../AccountLinkedinDialogError';
import { DialogStyle } from './style';

type AccountLinkedinDialogContentProps = {
  error: AxiosError | null,
  linkedinUrl: string,
  onLinkedInValueChanged: (e:React.ChangeEvent<HTMLInputElement>) => void,
  isLoading: boolean,
  label: string,
  }

const style = {
  loader: {
    sx: {
      position: 'absolute',
      top: '45%',
      left: '45%',
    },
  },
  label: {
    sx: {
      color: 'primary.text',
    },
  },
} as const;

export default function AccountLinkedinDialogContent({
  linkedinUrl,
  error,
  onLinkedInValueChanged,
  isLoading,
  label,
}:AccountLinkedinDialogContentProps): JSX.Element {
  const { t: translate } = useTranslation();

  const getErrorMessage = () => {
    if (!error) {
      return '';
    }

    return (
      error.response?.data?.fieldsErrors?.[0] ||
      error.response?.data?.message ||
      error.message ||
      translate(STRING_KEYS.GENERAL_SERVER_ERROR)
    );
  };

  const defineInput = () => {
    return (
      <TextField
        autoFocus
        id="name"
        label={ label }
        InputLabelProps={ style.label }
        type="text"
        placeholder={ translate(STRING_KEYS.LINKEDIN_URL) }
        fullWidth
        variant="outlined"
        value={ linkedinUrl }
        onChange={ onLinkedInValueChanged }
        InputProps={ {
          startAdornment:
  <Linkedin
    style={  DialogStyle.linkedIn }
  />,
        } }
      />
    );
  };

  const getContent = () => {
    return (
      <>
        {defineInput()}
        {error && (
          <AccountLinkedinDialogError
            Icon={ BrokenImage }
            message={ getErrorMessage() }
          />
        )}
      </>
    );
  };

  return (
    <DialogContent sx={ DialogStyle.dialogContent }>
      {isLoading ? (
        <Box sx={ style.loader.sx }>
          <CircularProgress />
        </Box>
      ) : getContent() }
    </DialogContent>
  );
}
